import api from './api';
import {
    mapOvertimeAccountDto,
    mapTotalOvertimeBalance
} from "../dto/OvertimeAccount";

export const getOvertimeBalances = async ({role, userId}) => {
    try {
        const res =
            role === 'admin'
                ? await api.get('/OvertimeAccount')
                : await api.get(`/OvertimeAccount/user/${userId}`);
        return res.data.map(mapOvertimeAccountDto);
    } catch (err) {
        console.error("Error get overtime balance:", err);
        throw err;
    }
};

export const getTotalOvertimeBalance = async ({userId}) => {
    try {
        const res = await api.get(`/OvertimeAccount/user/calculate_total/${userId}`);
        return mapTotalOvertimeBalance(res.data);
    } catch (err) {
        console.error("Error get total overtime balance:", err);
        throw err;
    }
};
